import { useEffect, useRef, useState } from 'react'

export function useClampToggle() {
  const ref = useRef(null)
  const [isClamped, setIsClamped] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const checkClamp = () => {
    if (!ref.current || isOpen) return

    const { scrollHeight, clientHeight } = ref.current
    setIsClamped(scrollHeight > clientHeight)
  }

  useEffect(() => {
    if (!ref.current) return

    const observer = new ResizeObserver(() => {
      checkClamp()
    })

    observer.observe(ref.current)

    return () => {
      observer.disconnect()
    }
  }, [isOpen])

  const toggle = () => setIsOpen((prev) => !prev)

  return {
    ref,
    isClamped,
    isOpen,
    toggle,
  }
}
